import { FC } from 'react';
import CarbonContributersPanel from './CarbonContributersPanel.component';
import CarbonFootprintOverviewPanel from './CarbonFootprintPanel.component';
import ParisAlignedPanel from './ParisAlignedPanel.component';
import NonPremiumSubscriptionDisplayMessage, {
  doesClientHavePremiumPackage,
} from '../NonPremiumSubscriptionDisplay/NonPremiumSubscriptionDisplayMessage.component';
import { Grid } from '@mui/material';
import { FundInfoComponentProps } from '../../../layout/general/SimpleGeneralPageWrapper';
import { QueryBoundary } from '../../../utilityComponents/QueryBoundary';
import {
  EsgPages,
  useEsgFundData,
  type EsgPortfolioSummaryPageModel,
} from '../../../../api/rs-hg/esg';

const PortfolioCarbonEmissions: FC<FundInfoComponentProps> = ({
  fundName,
  fundId,
  positionDate,
}) => {
  const portfolioSummaryQuery = useEsgFundData(
    fundId,
    positionDate,
    EsgPages.CARBON_EMISSIONS,
  );

  return (
    <QueryBoundary<EsgPortfolioSummaryPageModel>
      isLoading={portfolioSummaryQuery.isLoading}
      isFetching={portfolioSummaryQuery.isFetching}
      isError={portfolioSummaryQuery.isError}
      error={portfolioSummaryQuery.error}
      data={
        portfolioSummaryQuery.data?.data &&
        Object.keys(portfolioSummaryQuery.data.data).length > 0 &&
        !('no data' in portfolioSummaryQuery.data.data)
          ? portfolioSummaryQuery.data
          : null
      }
      loadingMessages={['Loading ESG Data...', '...']}
      errorMessage="No ESG Data Found"
      noDataMessage="No ESG Data Found"
    >
      {(pageModel) =>
        doesClientHavePremiumPackage(pageModel.data) ? (
          <Grid container spacing={2} style={{ padding: 8 }}>
            <CarbonFootprintOverviewPanel
              data={pageModel.data}
              fundId={fundId}
              fundName={fundName}
              positionDate={
                pageModel.returned_position_date ??
                pageModel.selected_position_date ??
                positionDate
              }
            />
            <ParisAlignedPanel data={pageModel.data} fundId={fundId} />
            <CarbonContributersPanel data={pageModel.data} />
          </Grid>
        ) : (
          <NonPremiumSubscriptionDisplayMessage />
        )
      }
    </QueryBoundary>
  );
};

export default PortfolioCarbonEmissions;
